import { err, ok, Result } from 'neverthrow'
import { AxiosError } from 'axios'
import { ExpertsClient } from 'HTTPClients/axios-clients/experts.client.ts'

export type TimeTrackingDataType = {
    user_id: string
    task_solved_date: Date
    form_values: {
        platform: string
        completed_tasks: number
        time: string
        task_solved_date: Date
        comments?: string
    }
    project_id: string
}

export type TimeTrackingResponseType = {
    user_id: string
    date: Date
    project_id: string
    created_at: number
    updated_at: number
    form_values: TimeTrackingDataType['form_values']
}

export type ProjectUserAssociationResponseType = {
    is_user_associated: boolean
}

export type ProjectFeatureFlags = {
    feature_flags: {
        job_profiling_enabled: boolean
        qc_editing: boolean
        stem_project: boolean
        turn_annotation_enabled: boolean
        is_ai_usage_confirmation_enabled: boolean
        lmf_project: boolean
        ots_project: boolean
    }
}
type TimeSheetEntriesType = {
    id: string
    user_id: string
    project_id: string
    form_value: {
        time: string
        comments?: string
        platform: string
        completed_tasks: number
        task_solved_date: string
    }
    task_solved_date: string
    platform: string
    created_at: string
    updated_at: string
}
export type TimeSheetEntriesResponseType = {
    timesheet_entries: TimeSheetEntriesType[]
}

export const getFeatureFlagsByProjectIdAPI = async (
    projectId: string,
    stepId?: string
): Promise<Result<ProjectFeatureFlags, AxiosError>> => {
    try {
        const resp = await ExpertsClient.get(`v1/internal-view/get-feature-flags`, {
            params: {
                project_id: projectId,
                step_id: stepId,
            },
        })
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const submitTimeTrackingDataAPI = async (
    data: TimeTrackingDataType
): Promise<Result<TimeTrackingResponseType, AxiosError>> => {
    try {
        const resp = await ExpertsClient.post(`v1/form-management/save-timesheet`, data)
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const checkProjectUserAssignedAPI = async (
    projectId: string,
    userId: string
): Promise<Result<ProjectUserAssociationResponseType, AxiosError>> => {
    try {
        const resp = await ExpertsClient.post(
            `v1/project-user-associations/check-project-user-association`,
            {
                project_id: projectId,
                user_id: userId,
            }
        )
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getTimeSheetEntriesAPI = async (
    userId: string,
    projectId: string
): Promise<Result<TimeSheetEntriesResponseType, AxiosError>> => {
    try {
        const resp = await ExpertsClient.get(
            `v1/form-management/timesheet-entries?user_id=${userId}&project_id=${projectId}`
        )
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}
